/* Copyright (c) 2020-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { When } from "react-if";
import { Can, ACTIONS } from "~/services/auth";
import { WhatsNewPopup } from "~/views/whatsnew/Whatsnew";
import {
  AccountStats,
  ApplicationStats,
  CloudWasteWidget,
  GlobalCostsWidget,
  HomeKPIWidget,
  TopSpendingAppsWidget,
} from "./components";
import { useOrgCosts } from "./hooks";
import { HomeAdminGrid, Span } from "./styles";

export function HomePageAdmin() {
  const { showCurrentMonth, isCurrentBillingPeriod } = useOrgCosts();

  return (
    <HomeAdminGrid>
      <Span xs={1} xxl={6} className="whatsnew">
        <WhatsNewPopup />
      </Span>
      <Span xs={1} xxl={6}>
        <GlobalCostsWidget />
      </Span>
      <Span xs={1} xxl={6}>
        <HomeKPIWidget />
      </Span>
      <Can action={ACTIONS.viewDashboardCharts}>
        <When condition={showCurrentMonth}>
          <Span xs={1} xxl={3}>
            <TopSpendingAppsWidget
              isCurrentBillingPeriod={isCurrentBillingPeriod}
            />
          </Span>
          <Span xs={1} xxl={3}>
            <CloudWasteWidget />
          </Span>
        </When>
        <Span xs={1} xxl={3}>
          <ApplicationStats />
        </Span>
        <Span xs={1} xxl={3}>
          <AccountStats />
        </Span>
      </Can>
    </HomeAdminGrid>
  );
}
